import { render, staticRenderFns } from "./MediationSummary.vue?vue&type=template&id=58ca5cc2&"
import script from "./MediationSummary.vue?vue&type=script&lang=js&"
export * from "./MediationSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports